import type { AssessmentFormUiConfig } from "./assessmentFormConfig";
import { stateKeyToRating } from "./assessmentFormConfig";
import type {
  AskReimagineAnswers,
  AskReimagineChatRequest,
  AskReimagineHistoryMessage,
  AskReimagineStartRequest,
  AxlPilotChatContext,
} from "../types/axlPilotContext";

type FormStateSlice = {
  currentState?: string;
  futureState?: string;
  currentStatusDescription?: string;
  futureStatusDescription?: string;
};

function ratingOrNull(
  stateKey: string | undefined,
  config: AssessmentFormUiConfig
): number | null {
  if (!stateKey) return null;
  const rating = stateKeyToRating(stateKey, config);
  return rating > 0 ? rating : null;
}

export function buildAskReimagineAnswers(
  formState: FormStateSlice | null | undefined,
  formConfig: AssessmentFormUiConfig
): AskReimagineAnswers {
  return {
    current_rating: ratingOrNull(formState?.currentState, formConfig),
    current_comment: (formState?.currentStatusDescription ?? "").trim(),
    future_rating: ratingOrNull(formState?.futureState, formConfig),
    future_comment: (formState?.futureStatusDescription ?? "").trim(),
  };
}

export function buildAskReimagineStartRequest(
  chatContext: AxlPilotChatContext
): AskReimagineStartRequest {
  return {
    assessment: chatContext.assessment,
    capability_id: chatContext.capability_id,
    sub_capability_id: chatContext.sub_capability_id,
  };
}

export function buildAskReimagineChatRequest(
  chatContext: AxlPilotChatContext,
  message: string,
  answers: AskReimagineAnswers,
  history: AskReimagineHistoryMessage[]
): AskReimagineChatRequest {
  return {
    assessment: chatContext.assessment,
    capability_id: chatContext.capability_id,
    sub_capability_id: chatContext.sub_capability_id,
    message: message.trim(),
    answers,
    history,
  };
}
